export default "__VITE_ASSET__C9h2MuWk__"